import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Input, InputNumber } from 'formik-antd';
import { FormInput, Box } from 'atoms';

const { Title } = Typography;

export function LRGoodsSummary({ isEditMode }) {
	return (
		<Box padding="1rem">
			<div style={{ textAlign: 'center' }}>
				<Title level={4}>Goods Summary</Title>
			</div>
			<Row gutter={12}>
				<Col span={12}>
					<FormInput name="goods_description" label="Description of Goods*">
						<Input
							name="goods_description"
							placeholder="Description"
							maxLength={20}
							disabled={!isEditMode}
						/>
					</FormInput>
				</Col>
				<Col span={12}>
					<FormInput name="declared_value" label="Declared Value*">
						<InputNumber
							name="declared_value"
							placeholder="Declared Value"
							controls={false}
							precision={2}
							style={{ width: '100%' }}
							disabled={!isEditMode}
						/>
					</FormInput>
				</Col>
			</Row>
			<Row gutter={12}>
				<Col span={12}>
					<FormInput name="gross_weight" label="Gross Weight*">
						<InputNumber
							name="gross_weight"
							placeholder="Gross Weight in Ton"
							controls={false}
							precision={2}
							style={{ width: '100%' }}
							disabled={!isEditMode}
						/>
					</FormInput>
				</Col>
				<Col span={12}>
					<FormInput name="unit_count" label="Unit Count">
						<InputNumber
							name="unit_count"
							placeholder="Unit Count"
							controls={false}
							precision={0}
							style={{ width: '100%' }}
							disabled={!isEditMode}
						/>
					</FormInput>
				</Col>
			</Row>
		</Box>
	);
}

LRGoodsSummary.propTypes = {
	isEditMode: PropTypes.bool,
};
